
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decks/[id]",
      function () {
        return require("private-next-pages/decks/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decks/[id]"])
      });
    }
  